const state = {
    productList:[],
  }
  
  const getters = {
    s_productList(state) {
      return state.productList
    },
  }
  
  const mutations = {
    
    SET_PRODUCTLIST: (state, productList) => {
      state.productList = productList
    },
  }
  
  const actions = {
    setProductList({commit}, productList) {
      commit('SET_PRODUCTLIST', productList)
    },
   
  }
  
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
  